import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const FilterRow = ({ data, uri }) => {
    const { filters } = data

    let baseUrl = uri.slice(0, uri.length-1);

    const handleSearch = (event) => {
        const query = event?.currentTarget?.value?.toLowerCase() // ?.trim()?.replace(/\s/g, '')
        const faqs = document.querySelectorAll('.faq-container')

        if (query?.length >= 3 && faqs?.length) {
            faqs.forEach(faq => {
                if (faq?.innerHTML?.toLowerCase()?.includes(query)) {
                    faq.style.display = 'block'
                } else {
                    faq.style.display = 'none'
                }
            })
        } else {
            faqs.forEach(faq => {
                faq.style.display = 'block'
            })
        }

    }

    return (
        <>
            <section className="filter-row">
                {filters ? filters.map((filter, i) => {
                    return (
                        <AnchorLink
                            key={i}
                            className="filter-btn"
                            to={`${baseUrl}${filter.filter.url.toLowerCase()}`}
                            title={filter.filter.title}
                        />
                    )
                }) : null}
            </section>
            <div className="filter-search">
                <input type="search" id="search" placeholder="Search..." onKeyUp={handleSearch} />
                <i class="gg-search"></i>
            </div>
        </>
    )
}

export default FilterRow
